
interface Iprops {
  class?: string,
  name: 'keyboard_arrow_down'
  | 'keyboard_arrow_left'
  | 'keyboard_arrow_right'
  | 'keyboard_arrow_up'
  | 'date_range'
  | 'calendar_today'
  | 'location_pin'
}
export default function Iconmoon(props: Iprops) {

  return <span className={'icon-' + props.name + " " + props.class}></span>;
}
